var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting2Off90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        stroke-linecap: round;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41.05-.71h7.16c2.76,0,5,2.24,5,5v24.74c0,2.76-2.24,5-5,5h-7.16V-.71h0Z",
    transform: "translate(63.79 -30.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m29.94,10.65s-19.44-2.69-19.44,25.53v28.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.85,
    y1: 16.66,
    x2: 64.41,
    y2: 16.66
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lig"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 12.43,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.59,
    y: 0
  }, "ting 2 - O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 56.49,
    y: 0
  }, "ff"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting2Off90);
export default __webpack_public_path__ + "static/media/__Lighting 2 - Off-90.7d5d487c55cc476e42f50c9584e5950f.svg";
export { ForwardRef as ReactComponent };